export default {
  // @ts-ignore
  prefix: "t",
};

// @ts-ignore
export const prefix = "t";
